/**
 * StocksPage - Wrapper для кэширования данных Остатков через React Query
 * НЕ изменяет логику Stocks.jsx, только кэширует API-запросы
 */
import { useQuery } from "@tanstack/react-query";
import api from "@/utils/api";
import Stocks from "@/pages/Stocks";

// Функции для загрузки данных
const fetchStocksData = async () => {
  const response = await api.get("/fast/stocks");
  return response.data;
};

const fetchSettings = async () => {
  const response = await api.get("/settings");
  return response.data;
};

const fetchSyncStatus = async () => {
  const response = await api.get("/sync/status");
  return response.data;
};

const fetchTurnover = async (period = 90) => {
  const response = await api.get(`/fast/turnover?period=${period}`);
  return response.data;
};

export default function StocksPage() {
  // Кэшированные запросы
  const stocksQuery = useQuery({
    queryKey: ["stocks"],
    queryFn: fetchStocksData,
  });

  const settingsQuery = useQuery({
    queryKey: ["settings"],
    queryFn: fetchSettings,
  });

  const syncStatusQuery = useQuery({
    queryKey: ["syncStatus"],
    queryFn: fetchSyncStatus,
  });

  const turnoverQuery = useQuery({
    queryKey: ["turnover", 90],
    queryFn: () => fetchTurnover(90),
  });

  // Собираем данные для передачи в компонент
  const cachedData = {
    stocks: stocksQuery.data?.items || [],
    synced: stocksQuery.data?.synced ?? false,
    settings: settingsQuery.data || { low_stock_threshold: 10 },
    syncStatus: syncStatusQuery.data || null,
    turnoverData: turnoverQuery.data?.items || [],
  };

  const isLoading = stocksQuery.isLoading || settingsQuery.isLoading;

  // Функция обновления кэша (для кнопки refresh)
  const refetchAll = async () => {
    await Promise.all([
      stocksQuery.refetch(),
      settingsQuery.refetch(),
      syncStatusQuery.refetch(),
      turnoverQuery.refetch(),
    ]);
  };

  // Передаём данные через props
  return (
    <Stocks
      cachedData={cachedData}
      cachedLoading={isLoading}
      onRefetch={refetchAll}
    />
  );
}
